'use client'
import { type FC } from 'react'
import styled from 'styled-components'
import { SectionHomeIntro } from './SectionHomeIntro'
import { SectionHomeGrid } from './SectionHomeGrid'
import { designGrid } from '@/styles'
import { TypeCmsHomepage } from '@/schema'
// import { useModal } from '@/hooks'
// import { MODALS } from '@/context'

type Props = {
  data: TypeCmsHomepage['gridImages']
}

const INTRO_DATA = [
  {
    title: {
      en: 'THE HOUSE',
      fr: 'THE HOUSE',
      de: 'THE HOUSE',
      es: 'THE HOUSE',
    },
    link: '/i/the-house',
    media: {
      alt: 'the house',
      m: {
        src: '/images/thehouse.jpg',
        size: {
          width: 1920,
          height: 1080
        }
      }
    }
  },
  {
    title: {
      en: 'ROOMS & SUITES',
      fr: 'CHAMBRES & SUITES',
      de: 'ZIMMER & SUITEN',
      es: 'HABITACIONES & SUITES',
    },
    link: '/suites',
    media: {
      alt: 'SUITES',
      m: {
        src: '/images/suites.jpg',
        size: {
          width: 1920,
          height: 1080
        }
      }
    }
  },
  {
    title: {
      en: 'FOOD & DRINK',
      fr: 'À BOIRE ET À MANGER',
      de: 'ESSEN & TRINKEN',
      es: 'COMIDA Y BEBIDA',
    },
    link: '/i/dining',
    media: {
      alt: 'DINING',
      m: {
        src: '/images/dining.jpg',
        size: {
          width: 1920,
          height: 1080
        }
      }
    }
  },
  {
    title: {
      en: 'WELLNESS',
      fr: 'BIEN-ÊTRE',
      de: 'WELLNESS',
      es: 'WELLNESS',
    },
    link: '/i/wellness',
    media: {
      alt: 'WELLNESS',
      m: {
        src: '/images/wellness.jpg',
        size: {
          width: 1920,
          height: 1080
        }
      }
    }
  },
]

export const MainHome:FC<Props> = ({ data }) => {
  // const { toggle, isActive } = useModal(MODALS.POP_UP)

  // useEffect(() => {
  //   if(!isActive) {
  //     setTimeout(() => {
  //       toggle()
  //     }, 3000)
  //   }
  // // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [])

  return (
    <Main>
      <SectionHomeIntro data={INTRO_DATA}/>
      <SectionHomeGrid data={data} />
    </Main>
  )
}

const Main = styled.main`
  ${designGrid({})}
`
